export default "__VITE_ASSET__B2bjM5sn__"